import { Link, useNavigate} from "react-router-dom";
import { useState } from "react";

import "./Navbar.css";

import ArgusUpdatedLogo from "../assets/ArgusWhiteLogo.png"

import Btn_rect from "./Btn_rect.js";


import { ChevronDown } from 'lucide-react';
import { CircleX } from "lucide-react";

const Navbar = () => {
  
  const navigate = useNavigate();

  const [navDark, setNavDark] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (window.scrollY > 5) setNavDark(true);
  //     else setNavDark(false);
  //   };
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  return (
    <nav className={`navbar ${navDark ? "nav-dark" : ""}`}>
      <div className="max_wrapper">
        <div className="nav-content">
           
          <div className="logo">
            <img src={ArgusUpdatedLogo} alt="Logo" />
          </div>
          <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
            <button className="close-btn" onClick={() => setMenuOpen(false)}>
               <CircleX size={48} strokeWidth={1} />
            </button>
            <li><Link to="/">Home</Link></li>
            <li className="dropdown">
              <a className="non_links">Technology
                   <ChevronDown className="dropdown-icon mobile-only" />
              </a>
              <ul className="dropdown-menu">
                <div className="dropdown_internal_flex">
                  <li className="non_links">Traceability</li>
                  <li><Link to='/supplychain'>Supply Chain Optimizations</Link></li>
                  <li><Link to='/predictive'>Predictive Maintenance</Link></li>
                </div>
                <div className="dropdown_internal_flex">
                  <li className="non_links">Safety</li>
                  <li><Link to='/security'>Security & Surveillance</Link></li>
                </div>
                <div className="dropdown_internal_flex">
                  <li className="non_links">Productivity</li>
                  <li><Link to='/smart'>Smart Inventory Management</Link></li>
                  <li><Link to='/enhanced'>Enhanced Customer Experience</Link></li>
                </div>
              </ul>
            </li>
            <li className="dropdown">
              <a className="non_links">Industry
                 <ChevronDown className="dropdown-icon mobile-only" />
              </a>
              <ul className="dropdown-menu">
                <div className="dropdown_internal_flex">
              
                  <li><Link to='/manufacturing'>Manufacturing Industry</Link></li>
                  <li><Link to='/construction'>Construction Industry </Link></li>
                </div>
                <div className="dropdown_internal_flex">
            
                  <li><Link to='/warehouse'>Warehouse Industry</Link></li>
                  <li><Link to='/logistics'>Logistics Industry</Link></li>
                </div>
                <div className="dropdown_internal_flex">
                  <li><Link to='/retail'>Retail Industry</Link></li>
                </div>
              </ul>
            </li>
            <li><Link to="/demo">Demo</Link></li>
             <li><Link to="/Pricing">Pricing</Link></li>

             <div className="contact-wrapper">
            <Btn_rect label="Contact Us" border_radius="300px"  onClick={()=>{navigate('/contact')}} />
          </div>

          </ul>
          
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        </div>
      </div>

        
       
       
    </nav>
  );
};

export default Navbar;
